import { ActionIcon, Menu, Text, Loader } from '@mantine/core';
import { IconLanguage, IconCheck } from '@tabler/icons-react';
import { useStore } from '@/store';
import { useLanguagesQuery, fetchAndApplyTranslation } from '@/models/Language';
import { useState } from 'react';
import style from './Style.module.scss';

export function Language() {
  const { language } = useStore();
  const { data: languages, isLoading } = useLanguagesQuery();
  const [switching, setSwitching] = useState(false);

  const handleLanguageSelect = async (langId: string) => {
    if (langId === language || switching) return;
    setSwitching(true);
    try {
      await fetchAndApplyTranslation(langId);
    } catch (error) {
      console.error('Failed to fetch translations:', error);
    } finally {
      setSwitching(false);
    }
  };

  return (
    <Menu shadow="md" width={180} position="bottom-end">
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="lg"
          aria-label="Language"
          loading={switching}
        >
          <IconLanguage size={20} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        {/* <Menu.Label>Language</Menu.Label> */}
        {isLoading ? (
          <div className={style.loaderWrapper}>
            <Loader size="sm" />
          </div>
        ) : (
          languages?.map((lang) => (
            <Menu.Item
              key={lang.id}
              onClick={() => handleLanguageSelect(lang.id)}
              rightSection={
                lang.id === language ? <IconCheck size={14} /> : null
              }
            >
              <Text
                size="sm"
                fw={lang.id === language ? 600 : 400}
              >
                {lang.name}
              </Text>
            </Menu.Item>
          ))
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
